import Util from '../../Common/Util';

export default class Info {
    constructor() {
    }
    init(order, member){
        this.order = {...order};
        this.member = {...member};
        this.info = {};
        
        // // 작업일시 : 2025-01-05 04:05:22
        // this.info['작업일시'] = this.order['work_time'];
        //
        // // 업종 : 스카이
        // this.info['업종'] = this.order['car_type'];
        //
        // 기종 : 1T 18~21M
        this.info['기종'] = $j.F.Car.getCarRangeStr(this.order, 1);

        // 옵션
        this.info['옵션'] = $j.F.Car.getCarOptionStr(this.order);

        // 결제 : 500,000P
        // this.info['금액'] = this.order['car_price'];

        // 수수료 : 10%
        let feeRate = 0;
        if (this.order['is_fee'] == 1) {
            feeRate = this.order['soo_fee_rate'];
            if (this.member['mem_ownercode'] == this.order['order_owner_num']) feeRate = this.order['bal_fee_rate'];
        }
        this.info['수수료율'] = feeRate;

        // 결제책임 : 싸인(익월말)
        let data = {
            'm': G5['HOW_TO_PAY'][Util.int(this.order['pay_method'])],
            'n': G5['SIGN_DUE'][this.order['sign_days']]
        };
        let str = data.m;
        if (this.order['pay_method'] == 1) {
            str += ` (${data.n})`;
        }
        this.info['결제책임'] = str;

        // 사용시간 : 12시간( 추가 주간1시간)
        // 회차 처리된 오더는 시간유형이 그대로 남아있으므로(회차는 is_return_job 만 세운다) '회차' 로 표기한다.
        // (서버 OrderConfirmationService::get 과 같은 규칙)
        str='';
        if( Util.int(this.order['is_return_job'])===1 && Util.int(this.order['order_status'])!==99 ) {
            str = '회차';
        } else if( this.order['car_workhour']>0 ) {
            str = $j.F.Car.getWorkHourStr(this.order);
        }
        this.info['사용시간'] = str;

        return this.info;
    }
}